<template>
    <section class="featured--publications">
        <FiltersPublications />
        <ul class="publications--list">
            <li class="publications--list-item"
            v-bind:class="{ 'half': isShortTitle(publication.title) }" v-for="publication in publications" 
            v-observe-visibility="{ callback: visibilityChanged, throttle: 300, once: true }" 
            :key="publication.id">
                
                <div class="publications--title-wrap">
                    <router-link class="publication-wrap" :to="{ name: 'Publication', params: {slug: publication.slug} }">
                        <img class="publication-cover"
                        v-bind:class="{ 'has-product': hasParution(publication) }"
                        :src="require(`@/assets/images/articles/${publication.thumb}`)"
                        :alt="publication.title"
                        >
                        <h3 class="publication-title">{{ publication.title }}</h3>
                    </router-link>
                    <router-link class="parution-wrap" v-if="hasParution(publication)" :to="{ name: 'Parution', params: {slug: publication.slug} }">
                        <img class="parution-cover"
                        :src="require(`@/assets/images/articles/${publication.product.covers.thumb}`)"
                        :alt="publication.title"
                        >
                    </router-link>
                </div>
            </li>
        </ul>
    </section>
</template>

<script>
import publicationsJSON from '@/content.js';
import FiltersPublications from '@/components/FiltersPublications'

export default {
  name: "ListPublications",
  components:{
      FiltersPublications
  },
  data(){
    return {
      publications: publicationsJSON.articles
    }
  },
  computed: {

  },
  methods: {
    isShortTitle($title){
        if($title.length <= 10){
            return true;
        }
    },
    hasParution($publication){
        if($publication.product){
            return true;
        }
    },
    visibilityChanged (isVisible, entry) {
        this.isVisible = isVisible;
        var element = entry.target;
        console.log(entry)
        if( isVisible ){
            element.classList.add('visible')
        } else {
            element.classList.remove('visible')
        }
    }
  }
};
</script>

<style lang="scss" scoped>
    @import "@/assets/styles/sass/components/_listPublications.scss";
</style>